import React from "react";
import { useNavigate } from "react-router-dom";
import AdventureMap from "../components/games/AdventureMap";
import { useEntitlementGate } from "../contexts/EntitlementGateContext";

const GamesPage = () => {
  const navigate = useNavigate();
  const { requireEntitlement } = useEntitlementGate();

  return (
    <div
      className="w-full"
      style={{
        minHeight: "100dvh",
        background: "linear-gradient(180deg, #BFE6FF 0%, #DFF3E4 55%, #FBF3D6 100%)",
      }}
    >
      {/* The map itself is browsable; entering any game is members-only.
          The gate runs via canLaunch BEFORE the zoom/cloud animation, so a
          blocked pick leaves the map untouched behind the wall.
          (The shared bubble-pop challenge route stays public by design —
          it's the beat-my-score share loop, reached via links, not here.) */}
      <AdventureMap
        canLaunch={() => requireEntitlement({ trigger: "games", contentType: "game" })}
        onSelect={(id) => navigate(`/games/${id}`)}
      />
    </div>
  );
};

export default GamesPage;
